export default {
  path: "/checkList",
  name: "checkList",
  redirect: "/check/List",
  meta: {
    title: "审批",
    showMainMenu: false,
  },
  children: [
    {
      path: "/check/List",
      name: "checkList",
      component: () =>
        import(/* webpackChunkName: "classroomMap" */ "@/views/check/List.vue"),
      meta: {
        title: "申请审批",
        showMainMenu: false,
        showFooter: false,
        icon: "icon-map",
      },
    },
    {
      path: "/check/Detail",
      name: "checkDetail",
      component: () =>
        import(/* webpackChunkName: "classroomMap" */ "@/views/check/Detail.vue"),
      meta: {
        title: "详情",
        showMainMenu: false,
        showFooter: false,
        icon: "icon-map",
      },
    },
  ],
}
